import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/login/evaluation.png'
import _imports_1 from '@/assets/currency/mh_logo.png'
import _imports_2 from '@/assets/home/unAuthorized.png'
import _imports_3 from '@/assets/home/outofdate.png'
import _imports_4 from '@/assets/home/isLimited.png'


const _withScopeId = n => (_pushScopeId("data-v-4c073cc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = {
  key: 0,
  class: "dvTopNoLogo"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "noLogo",
  src: _imports_0
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "dvTop" }
const _hoisted_6 = { class: "dvTopLeft" }
const _hoisted_7 = {
  key: 0,
  class: "dvTopLeftLogo"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "机灵树"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "dvTopLeftTitle"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "dvTopRightTitle"
}
const _hoisted_13 = { class: "dvTopRightInfo" }
const _hoisted_14 = { class: "dvTopRightSchoolInfo" }
const _hoisted_15 = { class: "w150 pSchoolInfo" }
const _hoisted_16 = { class: "w150 pSchoolInfo ml5" }
const _hoisted_17 = { class: "dvTopRightInfoName" }
const _hoisted_18 = { class: "w150 dvTopRightInfoNameInfo" }
const _hoisted_19 = { class: "dvTopRightInfoNameBtn" }
const _hoisted_20 = { class: "dvBottom" }
const _hoisted_21 = {
  key: 1,
  class: "deviceCheckBtn"
}
const _hoisted_22 = {
  key: 2,
  class: "deviceCheckBtn"
}
const _hoisted_23 = {
  key: 0,
  class: "dvPop"
}
const _hoisted_24 = {
  key: 1,
  class: "dvPassWord"
}
const _hoisted_25 = { class: "dvPassWordPop" }
const _hoisted_26 = { class: "dvPassWordInfo" }
const _hoisted_27 = { class: "dvPassWordPopMid" }
const _hoisted_28 = { class: "dvInputPassword" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w180" }, "原密码", -1))
const _hoisted_30 = { class: "dvElInput" }
const _hoisted_31 = { class: "dvInputPassword" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w180" }, "新密码", -1))
const _hoisted_33 = { class: "dvElInput" }
const _hoisted_34 = { class: "dvInputPassword" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w180" }, "重复新密码", -1))
const _hoisted_36 = { class: "dvElInput" }
const _hoisted_37 = { class: "dvLoginBtn" }
const _hoisted_38 = { class: "authorization-mask" }
const _hoisted_39 = { class: "authorization" }
const _hoisted_40 = {
  key: 0,
  class: "unAuthorized"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_42 = { class: "showAuthMessage" }
const _hoisted_43 = {
  key: 1,
  class: "outofdate"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_45 = { class: "showAuthMessage" }
const _hoisted_46 = {
  key: 2,
  class: "isLimited"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_48 = { class: "showAuthMessage" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loadingMask" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.store.state.noLogo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (!_ctx.store.state.noLogo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (!_ctx.store.state.noLogo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " · 艺术素质测评系统 "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isAndroid)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.schoolName), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.grade) + _toDisplayString(_ctx.classNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.name), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      class: "w120 btnLogin",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.btnAccountManage && _ctx.btnAccountManage(...args)))
                    }, " 账号管理 ")
                  ])
                ])
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", {
          class: "dvBottomCard dvBottomCardExam ml2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoExam && _ctx.gotoExam(...args)))
        }),
        _createElementVNode("div", {
          class: "dvBottomCard dvBottomCardMockExam ml2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoMockExam && _ctx.gotoMockExam(...args)))
        }),
        _createElementVNode("div", {
          class: "dvBottomCard dvBottomCardFreePractice ml2",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.gotoFreePractice && _ctx.gotoFreePractice(...args)))
        })
      ]),
      (_ctx.loginType === _ctx.LoginType.Token || _ctx.loginType === _ctx.LoginType.Username)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "btnBack",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.gotoAndroid && _ctx.gotoAndroid(...args)))
            }, "返 回")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "dvCloseBtn",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeApp && _ctx.closeApp(...args)))
            })
          ]))
    ]),
    (_ctx.displayPop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "dvPopBtn",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.gotoLogin && _ctx.gotoLogin(...args)))
          }, "退出登录"),
          _createElementVNode("div", {
            class: "dvPopBtn",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.btnReset && _ctx.btnReset(...args)))
          }, "重置密码")
        ]))
      : _createCommentVNode("", true),
    (_ctx.displayPassWord)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.name) + "同学,请按以下操作修改密码", 1),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_el_input, {
                    onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.focusSearchFor('oldPassword'))),
                    onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.blurSearchFor('oldPassword'))),
                    placeholder: _ctx.placeholderOldPassword,
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.password) = $event)),
                    clearable: "",
                    "show-password": ""
                  }, null, 8, ["placeholder", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_el_input, {
                    onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.focusSearchFor('newPassword'))),
                    onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.blurSearchFor('newPassword'))),
                    placeholder: _ctx.placeholderNewPassword,
                    modelValue: _ctx.newPassword,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newPassword) = $event)),
                    clearable: "",
                    "show-password": ""
                  }, null, 8, ["placeholder", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_el_input, {
                    onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.focusSearchFor('againNewPassword'))),
                    onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.blurSearchFor('againNewPassword'))),
                    placeholder: _ctx.placeholderAgainNewPassword,
                    modelValue: _ctx.againNewPassword,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.againNewPassword) = $event)),
                    clearable: "",
                    "show-password": ""
                  }, null, 8, ["placeholder", "modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                class: "btnLogin",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.btnChangePassword && _ctx.btnChangePassword(...args)))
              }, "确 认"),
              _createElementVNode("button", {
                class: "ml100 btnClose",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.btnCancel && _ctx.btnCancel(...args)))
              }, "取 消")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAuthorized)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 2,
          to: "body"
        }, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (_ctx.authResultType === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.authResultMessage), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.closeApp && _ctx.closeApp(...args)))
                    }, "退出程序")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.authResultType === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.authResultMessage), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.closeApp && _ctx.closeApp(...args)))
                    }, "退出程序")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.authResultType === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.authResultMessage), 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closeApp && _ctx.closeApp(...args)))
                    }, "退出程序")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.authLoading)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 3,
          to: "body"
        }, [
          _hoisted_49
        ]))
      : _createCommentVNode("", true)
  ], 64))
}